var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIconPlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F25600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95487 16.2191L8 13.8261C10.9893 10.1657 13.5786 10.3075 15.0173 11.5989C16.456 12.8903 16.1679 14.6223 15.8238 16.3631C15.4797 18.1039 15.8195 19.044 16.8066 19.1597C17.6905 19.2644 18.3593 18.7583 18.9442 17.5411C19.4453 16.4983 19.4281 14.7009 19.4131 13.3375C19.4109 13.1084 19.4088 12.8925 19.4088 12.694C19.4088 12.0723 19.4109 11.0906 19.4131 10.1984C19.4131 9.55927 19.4152 8.96592 19.4152 8.58418C18.5829 8.93975 18.155 8.79359 17.8475 8.69107C17.8216 8.68234 17.798 8.67361 17.7743 8.66707C17.512 8.58199 16.7162 8.06718 16.8281 7.06809C16.9292 6.1759 17.7184 5.89013 18.2023 6.03629C18.6862 6.18244 18.8754 6.71471 18.8754 6.71471C18.8754 6.71471 19.2088 6.19553 19.9163 6.20426C20.755 6.21298 21.3077 7.38222 21.3077 7.38222L21.3013 7.38658L23.4798 6.50965L23.1013 7.91666L24.1163 8.33768L23.4217 8.98992C24.3916 9.57672 24.2303 10.6718 23.4002 10.8856L23.3766 10.8921C23.3766 10.8921 25.4755 14.8186 26.4669 17.4494C28.6196 23.1647 23.7809 26.5612 20.3593 26.8382L20.1593 29H18.669L18.4625 26.7881C18.3184 26.7706 18.1743 26.7488 18.0216 26.7204C16.0431 26.343 14.2001 25.272 13.4065 23.9871C12.7829 22.9771 12.4001 21.7054 12.5506 20.1326C12.5786 19.8446 12.6474 19.5087 12.7226 19.1488C12.97 17.9599 13.271 16.5092 12.2818 15.7065C11 14.6616 9.95487 16.2191 9.95487 16.2191ZM22.1271 8.48383C22.0002 8.23079 21.7163 8.11735 21.4927 8.23297C21.2711 8.34858 21.1937 8.64744 21.3206 8.90048C21.4475 9.15352 21.7314 9.26696 21.955 9.15134C22.1787 9.03791 22.2561 8.73906 22.1271 8.48383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconPlk);
export default __webpack_public_path__ + "static/media/map-icon-plk.d1af75e8bb32ad9b0a02fada594a1752.svg";
export { ForwardRef as ReactComponent };